import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'pci-navbar',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit, OnDestroy {
    links = [
        { path: '/', label: 'Home' },
        { path: '/solutions', label: 'Solutions' },
        { path: '/news', label: 'News' },
        { path: '/publications', label: 'Publications' }
    ];
    activeLink: string | null = null;
    private _sub?: Subscription;

    @Output() linkClicked = new EventEmitter<{ path: string; label: string }>();

    constructor(private readonly router: Router) {}

    ngOnInit(): void {
        // Initial determination
        this.setActiveFromUrl(this.router.url);

        this._sub = this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe((evt: any) => this.setActiveFromUrl(evt.urlAfterRedirects || evt.url));
    }

    ngOnDestroy(): void {
        this._sub?.unsubscribe();
    }

    private setActiveFromUrl(url: string): void {
        // Find first link whose path is included in the current URL.
        // Prioritize longer paths to avoid '/' matching everything.
        const sorted = [...this.links].sort((a, b) => b.path.length - a.path.length);
        const match = sorted.find(
            l =>
                url === l.path ||
                url.startsWith(l.path + '/') ||
                (l.path !== '/' && url.includes(l.path))
        );
        this.activeLink = match ? match.path : null;
    }

    onLinkClick(link: { path: string; label: string }): void {
        setTimeout(() => this.linkClicked.emit(link), 100);
    }
}
